export const eBizTitleOptions = [
    {
        label: "Nhân viên",
        value: "NV",
        key: "NV"
    },
    {
        label: "Ca trưởng",
        value: "CT",
        key: "CT"
    
    },
    {
        label: "Nhóm trưởng",
        value: "NT",
        key: "NT"
    
    },
    {
        label: "Cán sự",
        value: "CN",
        key: "CN"
    
    },
    {
        label: "Chuyên viên",
        value: "CV",
        key: "CV"
    
    },
    {
        label: "Chuyên viên - KCQ",
        value: "CVKCQ",
        key: "CVKCQ"
    
    },
    {
        label: "Kíp phó",
        value: "KP",
        key: "KP"
    
    },
    {
        label: "Kíp trưởng",
        value: "KT",
        key: "KT"
    
    },
    {
        label: "Đội phó",
        value: "Đ",
        key: "Đ"
    
    },
    { 
        label: "Đội phó - KCQ",
        value: "DP",
        key: "DP"
    
    },
    {
        label: "Đội trưởng",
        value: "ĐT",
        key: "ĐT"
    
    },
    {
        label: "Đội trưởng - KCQ",
        value: "DT",
        key: "DT"
    
    },
    {
        label: "Giáo viên",
        value: "GV",
        key: "GV"
    
    },
    {
        label: "Phó trung tâm",
        value: "PTT",
        key: "PTT"
    },
    {
        label: "Trưởng trung tâm",
        value: "TTT",
        key: "TTT"
    
    },
    {
        label: "Phó phòng",
        value: "PP",
        key: "PP"
    
    },
    {
        label: "Trưởng Phòng",
        value: "TP",
        key: "TP"
    
    },
    {
        label: "Supervisor",
        value: "SSUPERVIS",
        key: "SSUPERVIS"
    
    },
    {
        label: "Phó giám đốc",
        value: "PGĐ",
        key: "PGĐ"
    },
    {
        label: "Giám đốc",
        value: "GD",
        key: "GD"
    },
]

export const eLocation = [
    {
        label: "Tân Sơn Nhất",
        value: "TSN",
        key: 1,
    },
    {
        label: "Nội Bài",
        value: "NBA",
        key: 2,
    },
    {
        label: "Đà Nẵng",
        value: "DAD",
        key: 3,
    },
]

export const eApproveTitleCode = "TP,PP,GD,PGĐ,TTT,PTT"